export interface FacetNode {
  key: string
  name: string
  count: number
  children: FacetTree
}

export type FacetTree = Record<string, FacetNode>
export type FacetData = Record<string, Record<string, number>>

export function transformFacetData(
  facetData: FacetData
): Record<string, FacetTree> {
  const sortChildrenByName = (tree: FacetTree): FacetTree => {
    const sortedEntries = Object.entries(tree)
      .sort(([nameA], [nameB]) => nameA.localeCompare(nameB))
      .map(([key, node]) => [
        key,
        { ...node, children: sortChildrenByName(node.children) }
      ])
    return Object.fromEntries(sortedEntries)
  }

  const transform = (data: Record<string, number>): FacetTree => {
    const tree: FacetTree = {}

    for (const [key, count] of Object.entries(data)) {
      const parts = key.split(' > ')
      let current = tree

      parts.forEach((part, index) => {
        if (!current[part]) {
          current[part] = {
            key: parts.slice(0, index + 1).join(' > '),
            name: part,
            count: index === parts.length - 1 ? count : 0,
            children: {}
          }
        }

        if (index === parts.length - 1) {
          current[part].count = count
        }

        current = current[part].children
      })
    }

    return sortChildrenByName(tree)
  }

  const transformed: Record<string, FacetTree> = {}
  for (const [facetKey, data] of Object.entries(facetData)) {
    transformed[facetKey] = transform(data)
  }

  return transformed
}
